import { render, staticRenderFns } from "./PODList.vue?vue&type=template&id=358bc965"
import script from "./PODList.vue?vue&type=script&lang=js"
export * from "./PODList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports